/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Pin_To_SidebarInputs */

const en_pin_to_sidebar = /** @type {(inputs: Pin_To_SidebarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pin ${i?.name} to the sidebar`)
};

/**
* | output |
* | --- |
* | "Pin {name} to the sidebar" |
*
* @param {Pin_To_SidebarInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const pin_to_sidebar = /** @type {((inputs: Pin_To_SidebarInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pin_To_SidebarInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_pin_to_sidebar(inputs)
});